import styled from '@emotion/styled'
import mq from 'theme/mediaQueries'

export const Container = styled.div`
  ${mq({
    display: ['block', 'block', 'grid'],
    gridTemplateColumns: ['100px', '60px auto 220px', '60px auto 300px'],
  })}
`

export const GroupDocument = styled.div`
  display: grid;
  grid-template-columns: auto 50px;
`
